<app-control-layout 
    [control]="formCtrl"
    [label]="label"
    [ignoreLabel]="ignoreLabel"
    [labelBlock]="labelBlock"
    [width]="width"
    [maxLength]="maxLength"
    [attr.id] ="idName">

    <!-- branch-prefixes -->
    <div class="row w-100 mx-0" *ngIf="dropdownType === 'branch-prefixes'">
        <div class="input-group">
            <div class="input-group-prepend" ngbDropdown>
                <button type="button" class="btn btn-outline-secondary dropdown-toggle py-0" placement="top" container="body" 
                    ngbTooltip="Select Branch Prefix" ngbDropdownToggle>
                    {{ selectedBranchPrefix }}
                </button>
                <div ngbDropdownMenu>
                    <a class="dropdown-item" (click)="setBranchPrefix('SNG')">SNG</a>
                    <a class="dropdown-item" (click)="setBranchPrefix('SNF')">SNF</a>
                    <a class="dropdown-item" (click)="setBranchPrefix('SNH')">SNH</a>
                    <a class="dropdown-item" (click)="setBranchPrefix('BAU')">BAU</a>
                    <a class="dropdown-item" (click)="setBranchPrefix('WEB')">WEB</a>
                    <a class="dropdown-item" (click)="setBranchPrefix('ALL')">ALL</a>
                </div>
            </div>
            <input class="form-control" type="textbox" [formControl]="formCtrl" [attr.id]="idName" [maxLength]="maxLength"/>
        </div>
    </div>

    <!-- product-prefixes -->
    <div class="row mx-0" *ngIf="dropdownType === 'product-prefixes'" [ngClass]="labelBlock ? 'width-minus-label' : 'w-100'">
        <div class="input-group">
            <div class="input-group-prepend" ngbDropdown>
                <button type="button" class="btn btn-outline-secondary dropdown-toggle py-0" placement="top" container="body" 
                    ngbTooltip="Select Product Prefix" ngbDropdownToggle>
                    {{ selectedProductPrefixLetter }}
                </button>
                <div ngbDropdownMenu>
                    <a class="dropdown-item" (click)="setProductPrefix('C')">C - Core</a>
                    <a class="dropdown-item" (click)="setProductPrefix('T')">T - Tool</a>
                    <a class="dropdown-item" (click)="setProductPrefix('B')">B - Bulk</a>
                    <a class="dropdown-item" (click)="setProductPrefix('W')">W - Workshop Consumable</a>
                    <a class="dropdown-item" (click)="setProductPrefix('S')">S - Sample</a>
                    <a class="dropdown-item" (click)="setProductPrefix('P')">P - Product</a>
                </div>
            </div>
            <input class="form-control" type="textbox" [formControl]="formCtrl" [attr.id]="idName" [maxLength]="maxLength" 
                [placeholder]="placeholder ? placeholder : ''"/>
        </div>
    </div>
</app-control-layout>